const RESET_KEY = "resettoken";
const PASSWORD_KEY = "pending-pw-change";

export const CONSTANT_KEYS = Object.freeze({
  PASSWORD_STORAGE_KEY: PASSWORD_KEY,
  RESET_TOKEN_STORAGE_KEY: RESET_KEY,
  UI_VERSION:
    process.env.VUE_APP_UI_VERSION_FLAG &&
    process.env.VUE_APP_UI_VERSION_FLAG.toLowerCase() === "true"
      ? "v2"
      : "",
});

export const APPROVAL_STATUS = [
  {
    label: "Approve",
    value: "Approve",
  },
  {
    label: "Completed",
    value: "Completed",
  },
];

export const DISCIPLINARY_RECORDS_UNIVERSITIES = [
  {
    name: "Bridgewater State University",
    email: "communitystandards@bridgew.edu",
  },
  {
    name: "Clemson University",
    email: "ljclay@clemson.edu",
  },
  {
    name: "San Diego State University",
    email: "csrr@sdsu.edu",
  },
  {
    name: "University of Nebraska-Lincoln",
    email: "studentconduct@unl.edu",
  },
  {
    name: "University of South Carolina-Columbia",
    email: "saosc@mailbox.sc.edu",
  },
];

export const GENDERS = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
  {
    label: "Non-binary",
    value: "nonBinary",
  },
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MAJORS = [
  {
    label: "Architecture",
    value: "Architecture",
  },
  {
    label: "Agriculture",
    value: "Agriculture",
  },
  {
    label: "Agribusiness",
    value: "Agribusiness",
  },
  {
    label: "Animal Science",
    value: "Animal Science",
  },
  {
    label: "Agroecology",
    value: "Agroecology",
  },
  {
    label: "Agriculture Education",
    value: "Agriculture Education",
  },
  {
    label: "Plant Science",
    value: "Plant Science",
  },
  {
    label: "General",
    value: "General",
  },
  {
    label: "Area, Ethnic, and Cultural Studies",
    value: "Area, Ethnic, and Cultural Studies",
  },
  {
    label: "Latin American Studies",
    value: "Latin American Studies",
  },
  {
    label: "European Studies",
    value: "European Studies",
  },
  {
    label: "Judaic and Near Eastern Studies",
    value: "Judaic and Near Eastern Studies",
  },
  {
    label: "Cultural Studies, General",
    value: "Cultural Studies, General",
  },
  {
    label: "Biological and Biomedical Sciences",
    value: "Biological and Biomedical Sciences",
  },
  {
    label: "Anatomy/Physiology",
    value: "Anatomy/Physiology",
  },
  {
    label: "Biochemistry",
    value: "Biochemistry",
  },
  {
    label: "Biology",
    value: "Biology",
  },
  {
    label: "Botany, Ecology, and Biodiversity",
    value: "Botany, Ecology, and Biodiversity",
  },
  {
    label: "Marine Biology",
    value: "Marine Biology",
  },
  {
    label: "Microbiology",
    value: "Microbiology",
  },
  {
    label: "Neuroscience",
    value: "Neuroscience",
  },
  {
    label: "Zoology",
    value: "Zoology",
  },
  {
    label: "Business",
    value: "Business",
  },
  {
    label: "Accounting and Related Services",
    value: "Accounting and Related Services",
  },
  {
    label: "Business Administration, Management and Operations",
    value: "Business Administration, Management and Operations",
  },
  {
    label: "Entrepreneurial and Small Business Operations",
    value: "Entrepreneurial and Small Business Operations",
  },
  {
    label: "Finance, Applied Economics, and Financial Management Services",
    value: "Finance, Applied Economics, and Financial Management Services",
  },
  {
    label: "Hospitality and Tourism Management",
    value: "Hospitality and Tourism Management",
  },
  {
    label: "Human Resources Management and Services",
    value: "Human Resources Management and Services",
  },
  {
    label: "International Business",
    value: "International Business",
  },
  {
    label: "Management Information Systems",
    value: "Management Information Systems",
  },
  {
    label: "Marketing and Advertising",
    value: "Marketing and Advertising",
  },
  {
    label: "Sports and Recreation Management",
    value: "Sports and Recreation Management",
  },
  {
    label: "Communication and Media Studies",
    value: "Communication and Media Studies",
  },
  {
    label: "Computer and Information Sciences",
    value: "Computer and Information Sciences",
  },
  {
    label: "Education",
    value: "Education",
  },
  {
    label: "Engineering",
    value: "Engineering",
  },
  {
    label: "Aerospace, Aeronautical and Astronautical Engineering",
    value: "Aerospace, Aeronautical and Astronautical Engineering",
  },
  {
    label: "Agricultural Engineering",
    value: "Agricultural Engineering",
  },
  {
    label: "Bioengineering/Biomedical/Medical Engineering",
    value: "Bioengineering/Biomedical/Medical Engineering",
  },
  {
    label: "Chemical Engineering",
    value: "Chemical Engineering",
  },
  {
    label: "Civil Engineering",
    value: "Civil Engineering",
  },
  {
    label: "Computer and Electrical Engineering",
    value: "Computer and Electrical Engineering",
  },
  {
    label: "Computer and Electronic Engineering",
    value: "Computer and Electronic Engineering",
  },
  {
    label: "Environmental/Environmental Health Engineering",
    value: "Environmental/Environmental Health Engineering",
  },
  {
    label: "Industrial Engineering",
    value: "Industrial Engineering",
  },
  {
    label: "Mechanical Engineering",
    value: "Mechanical Engineering",
  },
  {
    label: "Petroleum Engineering",
    value: "Petroleum Engineering",
  },
  {
    label: "English Language and Literature",
    value: "English Language and Literature",
  },
  {
    label: "Language",
    value: "Language",
  },
  {
    label: "Literature",
    value: "Literature",
  },
  {
    label: "Writing",
    value: "Writing",
  },
  {
    label: "Environmental, Natural Resource, and Conservation Studies",
    value: "Environmental, Natural Resource, and Conservation Studies",
  },
  {
    label: "Foreign Languages, Literatures, and Linguistics",
    value: "Foreign Languages, Literatures, and Linguistics",
  },
  {
    label: "Arabic Language and Literature",
    value: "Arabic Language and Literature",
  },
  {
    label: "Chinese Language and Literature",
    value: "Chinese Language and Literature",
  },
  {
    label: "Celtic Languages and Literatures",
    value: "Celtic Languages and Literatures",
  },
  {
    label: "Classics and Classical Languages and Literatures",
    value: "Classics and Classical Languages and Literatures",
  },
  {
    label: "Comparative and Related Language Studies",
    value: "Comparative and Related Language Studies",
  },
  {
    label: "Eastern European Languages and Literatures",
    value: "Eastern European Languages and Literatures",
  },
  {
    label: "German Language and Literature",
    value: "German Language and Literature",
  },
  {
    label: "Spanish Language and Literature",
    value: "Spanish Language and Literature",
  },
  {
    label: "French Language and Literature",
    value: "French Language and Literature",
  },
  {
    label: "Italian Language and Literature",
    value: "Italian Language and Literature",
  },
  {
    label: "Linguistics",
    value: "Linguistics",
  },
  {
    label: "Health Sciences",
    value: "Health Sciences",
  },
  {
    label: "Food Science/Nutrition",
    value: "Food Science/Nutrition",
  },
  {
    label: "Nursing",
    value: "Nursing",
  },
  {
    label: "Public Health",
    value: "Public Health",
  },
  {
    label: "Sports and Exercise Science/Kinesiology",
    value: "Sports and Exercise Science/Kinesiology",
  },
  {
    label: "History",
    value: "History",
  },
  {
    label: "Mathematics and Statistics",
    value: "Mathematics and Statistics",
  },
  {
    label: "Philosophy",
    value: "Philosophy",
  },
  {
    label: "Physical Sciences",
    value: "Physical Sciences",
  },
  {
    label: "Astronomy and Astrophysics",
    value: "Astronomy and Astrophysics",
  },
  {
    label: "Atmospheric Sciences and Meteorology",
    value: "Atmospheric Sciences and Meteorology",
  },
  {
    label: "Chemistry",
    value: "Chemistry",
  },
  {
    label: "Geological and Earth Sciences/Geosciences",
    value: "Geological and Earth Sciences/Geosciences",
  },
  {
    label: "Materials Sciences",
    value: "Materials Sciences",
  },
  {
    label: "Physics",
    value: "Physics",
  },
  {
    label: "Religious Studies",
    value: "Religious Studies",
  },
  {
    label: "Social Sciences",
    value: "Social Sciences",
  },
  {
    label: "Anthropology and Archaeology",
    value: "Anthropology and Archaeology",
  },
  {
    label: "Criminology, Law, and Legal Studies",
    value: "Criminology, Law, and Legal Studies",
  },
  {
    label: "Economics",
    value: "Economics",
  },
  {
    label: "Geography and Cartography",
    value: "Geography and Cartography",
  },
  {
    label: "International Relations and National Security Studies",
    value: "International Relations and National Security Studies",
  },
  {
    label: "Political Science and Government",
    value: "Political Science and Government",
  },
  {
    label: "Psychology",
    value: "Psychology",
  },
  {
    label: "Sociology, Social Policy, and Social Work",
    value: "Sociology, Social Policy, and Social Work",
  },
  {
    label: "Women, Gender and Sexuality Studies",
    value: "Women, Gender and Sexuality Studies",
  },
  {
    label: "Visual and Performing Arts",
    value: "Visual and Performing Arts",
  },
  {
    label: "Art History",
    value: "Art History",
  },
  {
    label: "Acting, Theater Arts, and Technical Theater",
    value: "Acting, Theater Arts, and Technical Theater",
  },
  {
    label: "Arts, Entertainment,and Media Management",
    value: "Arts, Entertainment,and Media Management",
  },
  {
    label: "Dance",
    value: "Dance",
  },
  {
    label: "Design, Fashion, and Applied Arts",
    value: "Design, Fashion, and Applied Arts",
  },
  {
    label: "Film/Video and Photographic Arts",
    value: "Film/Video and Photographic Arts",
  },
  {
    label: "Fine and Studio Arts",
    value: "Fine and Studio Arts",
  },
  {
    label: "Music",
    value: "Music",
  },
];
